<div id="layout-topbar" class="layout-topbar">
    <div class="layout-topbar-wrapper">
        <div class="layout-topbar-left">
            <div class="layout-topbar-logo flex align-items-end gap-3" id="logolink" style="cursor: pointer; outline: none;">
                <img *ngIf="selectedClientId" height="40" 
                    [src]="'data:image/png;base64,' + clientLogo" alt="{{clientName}}"
                    routerLink="/user/search/document-grid">
                <img *ngIf="!selectedClientId" src="../../../../../assets/layout/images/logoFigma.png" width="140"
                    class="mt-2" style="height: 20%;" (click)="onClickBackToSearchDocuments()" alt="Cozentus">
                <!-- <span *ngIf="!selectedClientId" class="freight-audit-text mt-3" (click)="onClickBackToSearchDocuments()">
                    Freight Audit
                  </span> -->
                <!--  -->
                <!--   <img *ngIf="selectedClientId" src="../../../../../assets/layout/images/logoFigma.png" width="90" class="mt-5"
                    style="height: 20%;" alt="Cozentus"> -->
                <span *ngIf="selectedClientId" class="freight-audit-text flex align-items-end gap-2">
                    <!-- <img *ngIf="selectedClientId" src="../../../../../assets/layout/images/fa-logo-bold.png" width="140"
                         style="height: 36px; width: 42px;" (click)="onClickBackToSearchDocuments()" alt="Cozentus"> -->
                    <span class="font-light">FREIGHT</span><div class="vertical-line"></div><span style="font-weight: 600;">AUDIT</span>
                </span>
            </div>
        </div>

        <div class="layout-topbar-right">
            <a class="menu-button" href="javascript:;" *ngIf="!router?.url.includes('document-viewer')"
                (click)="appMain.onMenuButtonClick($event)" aria-label="Menu Toggle Button">
                <i class="pi pi-bars"></i>
            </a>
            <div class="menuTitle">
                <!-- <h5 style="margin:0px;">{{viewInfo}}</h5> -->
                <!-- <p>{{menuTitle}}</p> -->
            </div>
            <!-- <a class="p-overlay-badge topbar-icon ml-2" style="color: #fff;" (click)="sendRefreshClickEvent()"
                href="javascript:;" pTooltip="Refresh (Ctrl+R)" aria-label="Refresh the Current Page">
                <i class="fas fa-sync-alt" [@rotatedState]='rotateState'></i>
            </a> -->
            <ul class="layout-topbar-actions">
                 <a class="p-overlay-badge topbar-icon ml-2" style="color: #fff;" (click)="sendRefreshClickEvent()"
                href="javascript:;" pTooltip="Refresh (Ctrl+R)" aria-label="Refresh the Current Page">
                <i class="fas fa-sync-alt" [@rotatedState]='rotateState'></i>
            </a>
                <!-- <a *ngIf="showExitButton == 'true' && !router?.url.includes('/user/search/application') && !router?.url.includes('document-viewer')"
                    href="javascript:;" (click)="onClickBackToSearchDocuments()" class="mr-3">
                    <button pButton pRipple type="button" icon="fas fa-sign-out-alt fa-flip-horizontal"
                        class="p-button-rounded round-icon-button exit-color" pTooltip="Exit Application"></button></a> -->
                <!-- <a href="javascript:;" class="p-overlay-badge topbar-icon " aria-label="Read Announcement">
                    <img *ngIf="isUnreadAnnouncement == 1" class="announcement-icon p-0" alt="Announcement"
                        pTooltip="Announcement(s)" pBadge src="../../../../../assets/layout/images/announcement.svg"
                        style="height: 2rem; width: 2rem">
                    <img *ngIf="isUnreadAnnouncement == 0" class="blink-icon p-0" alt="announcement-blinking"
                        pTooltip="Announcement(s)" (click)="onClickShowAnnouncement()" pBadge
                        src="../../../../../assets/layout/images/announcement.svg" style="height: 2rem; width: 2rem">
                </a> -->

                <a href="javascript:;" aria-label="View Notifications" class="pl-3"
                    (click)="appMain.onTopbarItemClick($event, notifications)">
                    <span class="p-overlay-badge topbar-icon" pTooltip="Notification(s)">
                        <i class="fas fa-bell" *ngIf="notificationCount > 0" pBadge size="small"
                            [value]="notificationCount > 9? '9+': notificationCount" severity="danger"></i>
                        <i class="fas fa-bell" *ngIf="notificationCount == 0" style="color: #fff !important;"
                            severity="danger"></i>
                        <!-- <img src="../../../../../assets/layout/images/bell (2).svg" severity="danger" style="height: 2rem; width: 2ren"/> -->
                    </span>
                </a>

                <li #notifications class="topbar-item notifications"
                    [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === notifications}">
                    <ul class="fadeInDown">
                        <li class="layout-submenu-header">
                            <h6 class="header-text">Notifications</h6>
                            <span class="p-badge">{{notificationCount}}</span>
                        </li>
                        <li role="menuitem" class="menu-item" *ngFor="let notification of notificationList">
                            <a href="javascript:;" class="flex justify-content-between"
                                (click)="appMain.onTopbarSubItemClick($event, 'DOC', notification)"
                                aria-label="Menu Toggle Button">
                                <!-- <i *ngIf="notification?.notificationType.includes('ETRACKER')" class="pi pi-envelope"></i>
                                <i *ngIf="notification?.notificationType.includes('DOCTRACKER')" class="pi pi-file"></i> -->
                                <div class="notifications-item" [pTooltip]="notification?.detail"
                                    [style]="{'opacity':notification.is_read == true?'0.6':'1'}"
                                    [ngClass]="{'unread': !notification.is_read, 'read': notification.is_read}">
                                    <div class="notification-header">
                                        <h6 class="title">{{notification.document_transaction_id}} | {{ notification?.title }}</h6>
                                        <p class="badge-status-dot">
                                            <span class="status-dot"
                                                [ngClass]="notification.is_read ? 'dot-red' : 'dot-green'"></span>
                                            <!-- {{ notification.is_read ? 'Read' : 'Unread' }} -->
                                        </p>
                                    </div>


                                    <p>{{notification?.short_description}}</p>

                                    <span class="text-sm">{{notification?.notification_received_on | date}} (UTC)</span>

                                </div>
                                <button pButton type="button" class="p-button-text p-button-danger h-1rem"
                                    (click)="onClickClearNotification($event, notification)" pTooltip="Clear"
                                    tooltipPosition="top" icon="pi pi-trash"></button>
                            </a>
                        </li>
                        <li class="my-1 p-2" *ngIf="notificationList?.length==0" class="menuitem"
                            style="text-align: center; display: block;">
                            <h6 class="text text-700">No Notifications yet !</h6>
                            <img style="width: 100px;" src="../../../../../assets/layout/images/bell.gif"
                                alt="no-notifications" />
                        </li>
                        <div *ngIf="notificationList?.length !== 0" class="p-2 sticky-bottom">
                            <div class="flex justify-content-end">
                                <!-- <button (click)="onClickNavigateToNotification()" pButton class="cozmos-primary-button" style="width: auto;"
                                    label="Mark All as Read"></button> -->
                                <button (click)="onClickClearNotification($event)" pButton class="text-button ml-4"
                                    label="Clear All"></button>
                            </div>
                        </div>
                    </ul>

                </li>

                <li #profile class="topbar-item user-profile"
                    [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === profile}">
                    <a href="javascript:void();" (click)="appMain.onTopbarItemClick($event,profile)"
                        aria-label="View User Profile" class="flex justify-content-center align-items-center gap-2">
                        <p-avatar [label]="firstLetter" shape="circle"></p-avatar>
                        <div class="profile-info">
                            <h6>{{userDetails?.first_name}} {{userDetails?.last_name}}</h6>
                            <span *ngIf="!selectedClientId && userDetails?.is_superuser">Super User</span>
                            <span *ngIf="selectedClientId" class="flex">
                                <span *ngIf="userDetails?.is_superuser">Super User</span>
                                <span *ngIf="!userDetails?.is_superuser">{{selectedUserRole}}</span>
                            </span>
                            
                        </div>
                          <i class="pi pi-chevron-down down-arrow-icon"></i>
                    </a>
                    <a *ngIf="showExitButton == 'true' && !router?.url.includes('/user/search/application') && !router?.url.includes('document-viewer')"
                        href="javascript:;" (click)="onClickBackToSearchDocuments()" class="mr-3">
                        <button pButton pRipple type="button" icon="fas fa-sign-out-alt fa-flip-horizontal"
                            class="p-button-rounded round-icon-button exit-color" pTooltip="Exit Application"
                            tooltipPosition="bottom"></button></a>
                        <ul class="fadeInDown">
                            <li class="menuitem">
                                <a href="javascript:;" (click)="onClickNavigateToProfilePage()">
                                    <i class="fa fa-user-circle" style="color: #19415e !important; font-size: 18px;"></i>
                                    <h6 class="p-0 my-2">Profile Overview</h6>
                                </a>
                            <!-- <li class="layout-submenu-header" (click)="onClickNavigateToProfilePage()"></li> -->
                                <!-- <p-avatar [label]="firstLetter" styleClass="mr-2" shape="circle"></p-avatar>
                                <div class="profile-info">
                                    <h6>{{userDetails?.first_name}} {{userDetails?.last_name}}</h6>
                                    <span *ngIf="!selectedClientId && userDetails?.is_superuser">Super User</span>
                                    <span *ngIf="selectedClientId" class="flex">
                                        <span *ngIf="userDetails?.is_superuser">Super User</span>
                                        <span *ngIf="!userDetails?.is_superuser">{{selectedUserRole}}</span>
                                        
                                    </span>
                                
                                </div> -->
                                
                            </li>
                            <!-- <li role="menuitem">
                                <a href="javascript:;" (click)="openHandbook()" aria-label="Support">
                                    <i class="pi pi-book"></i>
                                    <h6>Freight Audit Handbook</h6>
                                </a>
                            </li> -->
                            <!-- <li role="menuitem">
                                <a href="https://d365.topdesk.net/" rel="noopener" target="_blank" aria-label="Support">
                                    <i class="pi pi-compass"></i>
                                    <h6><u>Support</u></h6>
                                </a>
                            </li> -->
                            <li role="menuitem">
                                <a href="javascript:;" (click)="logoutConfirmation = true" aria-label="Logout">
                                    <i class="fas fa-power-off" style="color: #19415e !important;"></i>
                                    <h6>Logout</h6>
                                </a>
                            </li>
                        </ul>
                </li>
            </ul>
        </div>
        <p-dialog header="Announcements" [modal]="true" [resizable]="false" [draggable]="false"
            [(visible)]="showAnnouncement" styleClass="w-7">
            <div class="pb-0 announcement-dialog-box">
                <div class="details-relate-box mb-3" *ngIf="announcementList?.length>0">
                    <p-accordion [multiple]="true" *ngFor="let detail of announcementList;let i = index">
                        <p-accordionTab [selected]="i === 0 ? true: false">
                            <ng-template pTemplate="header">
                                <div class="displayContent">
                                    <div>{{detail?.title}}</div>
                                    <div *ngIf="detail?.file_content">
                                        <a href="javascript:;" aria-label="Download" class="ml-2"
                                            pTooltip="Download Attachement"
                                            (click)="downloadPDF(detail?.file_content,detail?.short_desc)"
                                            tooltipPosition="top">
                                            <i class="pi pi-download"></i>
                                        </a>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="content">
                                <div class="p-card-subtitle p-2" *ngIf="detail?.long_desc">
                                    <div class="p-my-1" [innerHTML]="detail?.long_desc"></div>
                                </div>
                            </ng-template>
                        </p-accordionTab>
                    </p-accordion>
                </div>
                <div class="details-relate-box mb-3" *ngIf="announcementList?.length==0">
                    <h4> There are No Announcements.</h4>
                </div>
            </div>
        </p-dialog>
        <!-- ----------------logout confirmation modal----------- -->
        <p-dialog [(visible)]="logoutConfirmation" [closable]="true" [modal]="true" [draggable]="false"
            [resizable]="false" [style]="{width: '30vw'}" header="Logout Confirmation">
            <div>
                <p *ngIf="!isManual">You are trying to logout from Freight Audit application which uses SSO login.</p>
                <p>
                    If you click on "YES" all your active sessions will be closed.
                    You still can close Browser/Tab to close the application.
                </p>
            </div>
            <hr />
            <div class="modalButtonAlign">
                <button pButton pRipple type="button" label="No" (click)="logoutConfirmation = false"
                    class="cozmos-secondary-button mr-2"></button>
                <button pButton pRipple type="button" label="Yes" class="cozmos-primary-button"
                    (click)="logOut()"></button>
            </div>
        </p-dialog>
    </div>
</div>